import React from 'react'; // eslint-disable-line no-unused-vars

import { LoadingSpinner } from '@motorway/motorway-storybook-cra';

import cx from 'classnames';

export default ({ className, ...rest }) => (
  <LoadingSpinner {...rest} className={cx('mw-loading-spinner', className)} />
);
